import { render, staticRenderFns } from "./approve-detail-anomaly.html?vue&type=template&id=767dca03&"
import script from "./approve-detail-anomaly.ts?vue&type=script&lang=ts&"
export * from "./approve-detail-anomaly.ts?vue&type=script&lang=ts&"
import style0 from "./approve-detail-anomaly.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports